import { Td, Text, Tr } from "@chakra-ui/react";
import * as React from "react";
import { t } from "i18next";

export const renderNoData = (colSpan) => {
  return <Tr>
    <Td colSpan={colSpan} textAlign="center">
      <Text>
        {t("noData")}
      </Text>
    </Td>
  </Tr>;
};